export const list = [{
		label: '学习领悟刘部长出席2025年推动“四好农村路”高质量发展现场会讲话精神',
		text: `2025年推动“四好农村路”高质量发展现场会召开深入学习贯彻习近平总书记重要指示精神推动“四好农村路”高质量发展取得新成效刘伟出席并讲话`,
		tags: ['中国特色社会主义', '交通运输部'],
		time: '2025年08月21日 08:32',
		page: "https://mp.weixin.qq.com/s/ACbPakhYS1lxcYMsGBkdLA",
		image: require('@/assets/image/newsMedia/incustryInfo/news_2.webp')
	}, {
		label: '科技赋能道路养护：AI 路面病害巡查设备与传统检测车对比实验获突破性成果',
		text: `近日，我司为期一周的 AI 路面病害识别技术与传统多功能检测车对比实验顺利收官。实验通过实地数据采集与多维度深度分析，系统评估了 AI 路面病害巡查设备在道路病害巡检中的应用效能。结果显示，AI 设备在巡检效率、覆盖范围、病害识别种类及智能化分析能力上有着良好表现，能为道路养护从传统模式向智能化升级提供扎实的实践支撑与决策参考。`,
		tags: ['信息化建设'],
		time: '2025年08月14日 17:28',
		page: "https://mp.weixin.qq.com/s/sj6GQz5kQ93rvGiC1wegAA",
		image: require('@/assets/image/newsMedia/incustryInfo/news_3.png')
	}, {
		label: '新品发布 | 更精准、高效！第Ⅱ代“羿路巡”AI巡查系统赋能养护数字化转型！',
		text: `传统道路巡查烦恼，您是否还在经历？人工巡查效率低，复杂区域易漏检？停车采集安全隐患大，早期病害难捕捉？被动养护成本高，小病害拖成大隐患？`,
		tags: ['信息化建设'],
		time: '2025年08月14日 17:28',
		page: "https://mp.weixin.qq.com/s/Q2JIGxOSBMAjZFGgwSYDUQ",
		image: require('@/assets/image/newsMedia/incustryInfo/news_4.png')
	}, {
		label: '科技赋能道路养护：AI 路面病害巡查设备与传统检测车对比实验获突破性成果',
		text: `近日，我司为期一周的 AI 路面病害识别技术与传统多功能检测车对比实验顺利收官。实验通过实地数据采集与多维度深度分析，系统评估了 AI 路面病害巡查设备在道路病害巡检中的应用效能。结果显示，AI 设备在巡检效率、覆盖范围、病害识别种类及智能化分析能力上有着良好表现，能为道路养护从传统模式向智能化升级提供扎实的实践支撑与决策参考。`,
		tags: ['信息化建设'],
		time: '2025年08月11日 17:05',
		page: "https://mp.weixin.qq.com/s/a1VkV0vVFNzOS3QtyO0krQ",
		image: require('@/assets/image/newsMedia/incustryInfo/news_5.jpg')
	}, {
		label: '交通运输部召开学习贯彻习近平新时代中国特色社会主义思想主题教育总结会议',
		text: `9月6日，交通运输部召开学习贯彻习近平新时代中国特色社会主义思想主题教育总结会议，
        传达学习贯彻习近平新时代中国特色社会主义思想主题教育第一批总结暨第二批部署会议精神，
        全面总结交通运输部系统主题教育开展情况，对下一步工作进行部署安排，巩固深化主题教育成果，
        进一步统一思想、统一意志、统一行动，为奋力加快建设交通强国、努力当好中国式现代化的开路先锋提供有力政治保障。
        交通运输部党组书记、部长李小鹏主持会议并讲话。中央第三十二指导组组长李微微及有关成员出席会议。`,
		tags: ['中国特色社会主义', '交通运输部'],
		time: '2023-09-07',
		page: "",
		image: require('@/assets/image/newsMedia/incustryInfo/news_1.jpg')
	},
	{
		label: '交通运输部推进国家公路现代养护工程试点',
		text: `
        <p style="margin-bottom: 16px">
         8月31日，交通运输部公路局在江苏盐城开展国家公路现代养护工程试点现场调研，
        贯彻落实《交通运输部办公厅关于开展国家公路现代养护工程试点的通知》精神，深入推进试点项目顺利实施。
        </p>
        <p>
        立足科学提升国家公路养护工程质量效益，引领公路养护工程现代化水平，交通运输部于今年5月确定10个项目作为2023年国家公路现代养护工程试点。
        围绕集中养护、智慧养护、长周期养护、绿色养护、快速养护等主题，各试点项目探索现代公路养护工程新理念、新技术、新模式，
        着力打造公路现代养护工程样板
        </p>
        `,
		tags: ['养护工程试点'],
		time: '2023-09-04',
		page: "",
		image: null
	},
	{
		label: '农村公路“一路一档”信息化建设试点细化要求',
		text: `
        <p style="margin-bottom: 16px">
         近日，交通运输部办公厅印发《关于做好农村公路“一路一档”信息化建设试点实施工作的通知》（简称《通知》），
         进一步明确农村公路“一路一档”信息化建设试点实施总体目标、工作安排和工作要求。
        </p>
        <p style="margin-bottom: 16px">
        根据《通知》，试点周期为两年，由天津等15个省级交通运输主管部门与部科学研究院、部公路科学研究院共同组成试点实施单位，
        负责试点任务具体实施工作。通过试点建设，探索形成农村公路“一路一档”信息化建设的典型模式，健全完善农村公路数据管理机制，
        引导加快推动农村公路数字化转型，实现农村公路基础数据“一张网”、数字化应用“一张图”、业务协同“一盘棋”、对外服务“一平台”。
        </p>
        <p>
        《通知》要求，各试点实施单位要切实加强组织领导，强化工作保障，形成工作合力，确保工作有序、高效开展；加强沟通对接，
        及时报送试点任务取得的成果经验和需要解决的问题；加大要素投入，积极协调争取资金、人才、技术支持；加大宣传力度，多渠道、
        多方式宣传试点成果和先进经验。
        </p>
        `,
		tags: ['“一路一档”', '信息化建设'],
		time: '2023-08-30',
		page: "",
		image: null
	},
	{
		label: '甘肃万公里自然村（组）通硬化路已完工86%',
		text: `
        <p style="margin-bottom: 16px">
         据日前召开的甘肃省推进“四好农村路”高质量发展现场会消息，今年以来，全省农村公路累计完成投资69.68亿元，
         1万公里自然村（组）通硬化路进展较快，已完工8642公里，完工比例86%，计划改造农村公路危旧桥梁120座，
         目前已完工68座，完成比例56.6%，计划实施村道安全生命防护工程3600公里，已完成3167公里，完工比例88%。
        </p>
        <p>
        “十四五”以来，甘肃省委、省政府连续三年将自然村（组）通硬化路列为民生实事，每年1万公里的建设规模位居全国前列，
        全省农村公路通达程度大幅提高、出行条件持续改善、服务品质稳步提升。
        </p>
        `,
		tags: ['自然村（组）通硬化路', '四好农村路'],
		time: '2023-08-30',
		page: "",
		image: null
	},
	{
		label: '《加快建设交通强国报告（2022）》正式发布',
		text: `
        <p style="margin-bottom: 16px">
         近日，交通运输部发布《加快建设交通强国报告（2022）》（简称《报告》），这是党的十九大报告提出建设交通强国以来，
         交通运输部第一次发布建设交通强国报告。《报告》对五年来加快建设交通强国工作成效经验进行了总结，贯彻落实党的二十大部署安排，
         谋划未来五年加快建设交通强国思路方向，对凝聚行业共识，奋力加快建设交通强国，努力当好中国式现代化的开路先锋具有重要意义。
         《报告》包括3章，共约2.9万字。
        </p>
        <p>
        第一章是开启加快建设交通强国新征程。对党的十八大以来习近平总书记关于交通运输重要论述进行了系统梳理，对党中央、
        国务院对加快建设交通强国的谋划部署进行了总结，阐述了各部门、各地区协同纵深推进交通强国建设情况，以及各单位参与交通强国建设试点情况。
        </p>
        `,
		tags: ['《加快建设交通强国报告（2022）》', '交通强国'],
		time: '2023-08-30',
		page: "",
		image: null
	},
	{
		label: '甘肃专班推进交通强国建设试点结硕果',
		text: `
        <p style="margin-bottom: 16px">
         连日来，甘肃兰州中川国际机场三期扩建工程项目建设如火如荼，进度持续刷新。该工程是国家交通基础设施重大工程建设项目，
         截至7月底，已累计完成投资264亿元，占概算总投资的78.95%。
        </p>
        <p style="margin-bottom: 16px">
        依托兰州中川国际机场三期扩建工程，甘肃将试点打造陆空立体一体化航空枢纽，优化航线网络布局。机场新建的T3航站楼建筑面积达40万平方米，
        比现有T1和T2航站楼的总和还要大4倍多，投入运营后将成为支撑“空中丝路”的新枢纽。
        </p>
        <p>
        2021年以来，甘肃交通运输部门围绕大敦煌交旅融合发展、航空枢纽一体化发展、车路协同创新发展、交通投融资体制机制创新研究、陇原乡村振兴“四好农村路”建设五项交通强国建设试点，
        成立工作专班，统筹推进各项试点任务取得实质性进展。
        </p>
        `,
		tags: ['甘肃兰州中川国际机场', '交通强国'],
		time: '2023-08-30',
		page: "",
		image: null
	},
	{
		label: '李小鹏：大力发展智慧交通 加快建设交通强国 为当好中国式现代化的开路先锋注入新动能',
		text: `
        <p style="margin-bottom: 16px">
         大力发展智慧交通 加快建设交通强国
        </p>
        <p style="margin-bottom: 16px">
         为当好中国式现代化的开路先锋注入新动能
        </p>
        <p>
        智慧交通是人工智能、物联网、大数据等新一代信息技术与交通运输深度融合的新业态，是推动交通运输质量变革、
        效率变革、动力变革的重要途径。习近平总书记高度重视智慧交通发展，多次作出重要指示，强调“要大力发展智慧交通和智慧物流，
        推动大数据、互联网、人工智能、区块链等新技术与交通行业深度融合，使人享其行、物畅其流”；要求“探索在信息基础设施、智慧交通、
        能源电力等领域的推广应用，提升城市管理的智能化、精准化水平”；明确“努力打造世界一流的智慧港口、绿色港口”，
        为智慧交通发展指明了前进方向、提供了根本遵循。交通运输部认真贯彻落实习近平总书记关于交通运输和科技创新工作的重要论述，
        不断增强以科技创新驱动加快建设交通强国的责任感、使命感、紧迫感，积极推动新一代信息技术与交通运输行业融合创新，大力发展智慧交通，
        为交通当好中国式现代化的开路先锋持续注入新动能。
        </p>
        
        `,
		tags: ['智慧交通', '信息基础设施'],
		time: '2023-09-13',
		page: "",
		image: null
	},
]